// ** Hook Import
import { useSettings } from 'src/@core/hooks/useSettings'

const GlobalStyles = theme => {
  // ** Hook & Var
  const { settings } = useSettings()

  const { mode } = settings

  const perfectScrollbarThumbBgColor = () => {
    if (mode === 'light') {
      return '#BFBFD5 !important'
    } else {
      return '#57596C !important'
    }
  }

  return {
    // ** Proxima Nova Font Family Declarations
    '@font-face': [
      // BLACK WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-BlackIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-BlackIt.woff") format("woff")',
        fontWeight: 900,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Black.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Black.woff") format("woff")',
        fontWeight: 900,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // EXTRA BOLD WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-ExtrabldIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-ExtrabldIt.woff") format("woff")',
        fontWeight: 800,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Extrabld.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Extrabld.woff") format("woff")',
        fontWeight: 800,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // BOLD WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-BoldIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-BoldIt.woff") format("woff")',
        fontWeight: 'bold',
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Bold.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Bold.woff") format("woff")',
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // SEMIBOLD WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-SemiboldIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-SemiboldIt.woff") format("woff")',
        fontWeight: 600,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Semibold.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Semibold.woff") format("woff")',
        fontWeight: 600,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // MEDIUM WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-MediumIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-MediumIt.woff") format("woff")',
        fontWeight: 500,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Medium.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Medium.woff") format("woff")',
        fontWeight: 500,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },

      // LIGHT WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-LightIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-LightIt.woff") format("woff")',
        fontWeight: 300,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Light.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Light.woff") format("woff")',
        fontWeight: 300,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // THIN WEIGHT
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-ThinIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-ThinIt.woff") format("woff")',
        fontWeight: 100,
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNovaT-Thin.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNovaT-Thin.woff") format("woff")',
        fontWeight: 100,
        fontStyle: 'normal',
        fontDisplay: 'swap'
      },
      // NORMAL WEIGHT (DEFAULT) - Load first
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-RegularIt.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-RegularIt.woff") format("woff")',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontDisplay: 'swap'
      },
      {
        fontFamily: 'Proxima Nova',
        src: 'url("/fonts/proxima-nova/ProximaNova-Regular.woff2") format("woff2"), url("/fonts/proxima-nova/ProximaNova-Regular.woff") format("woff")',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontDisplay: 'swap'
      }
    ],
    // ** Consistent, lighter placeholder color across every input/textarea (MUI and native)
    'input::placeholder, textarea::placeholder': {
      color: theme.palette.text.disabled,
      opacity: 1
    },
    // ** Kill the browser's autofill paint job everywhere (this is why "Select
    // Role" / "Current Password" / "Password" can still look tinted even
    // though the theme's OutlinedInput background is white). Chrome/Edge/Safari
    // don't respect background-color on autofilled inputs — they paint their
    // own color using an internal box-shadow layer. The only reliable
    // counter-measure is to override that layer directly, and delay the
    // built-in transition so it never gets a chance to flash the native color.
    'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 1000px #FFFFFF inset !important',
      boxShadow: '0 0 0 1000px #FFFFFF inset !important',
      WebkitTextFillColor: `${theme.palette.text.primary} !important`,
      caretColor: theme.palette.text.primary,
      transition: 'background-color 600000s ease-in-out 0s, color 600000s ease-in-out 0s'
    },
    '.demo-space-x > *': {
      marginTop: '1rem !important',
      marginRight: '1rem !important',
      'body[dir="rtl"] &': {
        marginRight: '0 !important',
        marginLeft: '1rem !important'
      }
    },
    '.demo-space-y > *:not(:last-of-type)': {
      marginBottom: '1rem'
    },
    '.MuiGrid-container.match-height .MuiCard-root': {
      height: '100%'
    },
    '.ps__rail-y': {
      zIndex: 1,
      right: '0 !important',
      left: 'auto !important',
      '&:hover, &:focus, &.ps--clicking': {
        backgroundColor: theme.palette.mode === 'light' ? '#F3F3F8 !important' : '#393B51 !important'
      },
      '& .ps__thumb-y': {
        right: '3px !important',
        left: 'auto !important',
        backgroundColor: theme.palette.mode === 'light' ? '#BFBFD5 !important' : '#57596C !important'
      },
      '.layout-vertical-nav &': {
        '& .ps__thumb-y': {
          width: 4,
          backgroundColor: perfectScrollbarThumbBgColor()
        },
        '&:hover, &:focus, &.ps--clicking': {
          backgroundColor: 'transparent !important',
          '& .ps__thumb-y': {
            width: 6
          }
        }
      }
    },
    '#nprogress': {
      pointerEvents: 'none',
      '& .bar': {
        left: 0,
        top: 0,
        height: 3,
        width: '100%',
        zIndex: 2000,
        position: 'fixed',
        backgroundColor: theme.palette.primary.main
      }
    }
  }
}

export default GlobalStyles
